import {
  FoodCustomisation,
  Modifier,
} from "src/app/services/merchant/food.service.base";
import { OrderStatuses } from ".";

export type ModifierSetting = Pick<Modifier, "name"> & {
  amount: number;
  price: number;
  totalPrice: number;
};
export type FoodCustomisationSetting = Pick<FoodCustomisation, "name"> & {
  modifiers: ModifierSetting[];
  totalPrice: number;
};

export enum ItemAdjustmentType {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  OUT_OF_STOCK_UNTIL_TMRW = "OUT_OF_STOCK_UTIL_TMRW",
  REMOVED = "REMOVED",
  QUANTITY_CHANGED = "QUANTITY_CHANGED",
}

export class AdjustmentDTO {
  type: ItemAdjustmentType;
  priceChange?: number;
  quantityChange?: number;
  reason?: string;
}
export type OrderItem = {
  id: string;
  itemName: string;

  amount: number;

  totalPrice: number;

  specialInstructions?: string;

  allergies?: string[];

  modifierGroups: FoodCustomisationSetting[];

  adjustments: AdjustmentDTO[];

  basePrice: number;
};

export enum OrderStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  PREPARING = "PREPARING",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  ORDER_TIMED_OUT = "ORDER_TIMED_OUT",
  PICKED_UP = "PICKED_UP",
  CANCELLED_BY_CUSTOMER = "CANCELLED_BY_CUSTOMER",
  CANCELLED_BY_RESTAURANT = "CANCELLED_BY_RESTAURANT",
  REJECTED_BY_RESTAURANT = "REJECTED_BY_RESTAURANT",
  REFUNDED = "REFUNDED",
  COMPLETED = "COMPLETED",
}

export enum DriverAssignmentStatus {
  ACCEPT = "ACCEPT",
  WAITING_RESTAURANT = "WAITING_RESTAURANT",
  DELIVERING = "DELIVERING",
  WAITING_CUSTOMER = "WAITING_CUSTOMER",
  FINISH = "FINISH",
  CANCELLED_BY_CUSTOMER = "CANCELLED_BY_CUSTOMER",
  CANCELLED_BY_RESTAURANT = "CANCELLED_BY_RESTAURANT",
  CANCELLED_BY_DRIVER = "CANCELLED_BY_DRIVER",
}

export type OrderDetail = {
  id: string;
  totalAllergiesRequest: number;

  orderNum: number;

  customerName: string;

  customerAvatar?: string;
  customerId: string;

  numberOfItems: number;

  items: OrderItem[];

  specialInstructions?: string;

  estimatedReadyTime: Date;

  deliveryAssignmentDriverStatus: DriverAssignmentStatus | null;
  hasEstTimeUpdated: boolean;

  originalPrice: number;

  finalPrice: number; // = priceAdjustment?.amount + originalPrice
  subTotal: number;
  vat: number;
  priceAdjustment?: {
    amount: number;
    reason: string;
  };

  createdAt: Date;
  status: OrderStatuses;
  isPickup: boolean;

  customerCancelReason?: string;
  restaurantCancelReason?: string;
};
